// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,


//ProyashCTG
  k: "VPcb6iNZUh3VS5X9E7CmNQ==",
  c: "65ElD52O19k=",

  //Default
  // c: "mi3xkNpDMBw=",
  // k: "OLCZ5OHN91o=",

  
  //LHRMSC
  // k: "qUklnbq/LUT8VmJzGxftyw==",
  // c: "nK9b8bkYpNc=",

  // c: "cicRrsStvcM=",
  // k: "GSJk0Rr4amQ=",
  // c: "9d9DiTkBwpbbC2ZMUmlHTQ==",
  // k: "EMzt6h8TXkY=",
  // Ramu
//   c: "cicRrsStvcM=",
//   k: "GSJk0Rr4amQ=",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
